module.exports = __webpack_public_path__ + "officialStatic/img/n3.6bd9af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n3.png
// module id = oB5p
// module chunks = 0